import React from 'react';
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  IconButton,
  Paper,
  CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Pagination from '../../../Common/Pagination/pagination';
import { TableDescription, TableRowStyled, TableWrapper } from '../../JobManagement/JobListing/JobListing.styles';
import { theme } from '../../../../theme';
import { PanelAndStakeholder } from './PanelStakeholders';
import ParticipantLabel from './ParticipantLabel';
import { StyledTableCell } from '../../CandidateManagement/CandidateContent/CandidateContent.styles';


interface PanelTableProps {
  totalCount: number;
  panelData: PanelAndStakeholder[];
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  loading: boolean; // <-- Add this prop
  handleEditMember: (value: number) => void;
  handlOpenDelteDialog: (value: number) => void;
}

const PanelTable: React.FC<PanelTableProps> = ({
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  totalCount,
  panelData,
  loading, // <-- Default to false
  handleEditMember,
  handlOpenDelteDialog
}) => {
  const columnsData = ['Username', 'Email Address', 'Role', 'Updated By', 'Actions']
  return (
    <TableWrapper elevation={0} sx={{ tableLayout: 'auto', mb: 2 }}>
      <Box sx={{ overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              {columnsData.map((column, index) => (
                <TableCell
                  key={column}
                  sx={{
                    color: theme.palette.text.secondary,
                    padding: '8px 12px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '13.89vw',
                    minWidth: '6.94vw',
                    textAlign: ['actions', 'role'].includes(column.toLowerCase()) ? 'center' : 'left',
                  }}
                >
                  <Typography variant='caption'>
                    {column.charAt(0).toUpperCase() + column.slice(1).replace(/_/g, ' ')}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>

          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columnsData.length} style={{ textAlign: 'center' }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : panelData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columnsData.length} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                  No Data Available
                </TableCell>
              </TableRow>
            ) : (
              panelData.map((row, index) => (
                <TableRowStyled
                  key={index}
                  iseven={(index % 2 === 0).toString()}
                >
                  <TableDescription>{row.UserName}</TableDescription>
                  <TableDescription>{row.EmailId}</TableDescription>
                  <TableDescription sx={{ textAlign: 'center' }}>
                    <ParticipantLabel role={row.RoleKey} />
                  </TableDescription>
                  <TableDescription>{row.UpdatedBy}</TableDescription>
                  <TableDescription sx={{ textAlign: 'center' }}>
                    <IconButton color="primary" size="small" onClick={() => handleEditMember(row.ParticipantID)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="primary" size="small" onClick={() => handlOpenDelteDialog(row.ParticipantID)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableDescription>
                </TableRowStyled>
              ))
            )}
          </TableBody>
        </Table>
      </Box>
      {
        totalCount > 0 && (
          <Box p={1}>
            <Pagination
              totalRows={totalCount}
              rowsPerPage={rowsPerPage}
              currentPage={page}
              onPageChange={onPageChange}
              onRowsPerPageChange={onRowsPerPageChange}
            />
          </Box>
        )
      }

    </TableWrapper>
  );
};

export default PanelTable;
